const capitalizeEveryWord = (str: string) =>
    str.replace(/\w\S*/g, w => w.replace(/^\w/, c => c.toUpperCase()).replace(/\B[A-Z]/g, c => c.toLowerCase()));
export default capitalizeEveryWord;
